import { filter, compose, shuffle, take, flatten } from 'lodash/fp'
// import { random } from '@elgatoylacaja/utils'

export type Argumento = {
  id: number
  text: string
  type: 'pro' | 'contra' | 'definicion'
}

export type Dilema = {
  id: number
  title: string
  text: string
  argumentos: Argumento[]
}

const pro = (arg: Argumento) => arg.type === 'pro'
const contra = (arg: Argumento) => arg.type === 'contra'

const condicion = (cantidad: number) => (
  filterCond: (x: Argumento) => boolean
) => (argumentos: Argumento[]): Argumento[] =>
  compose(take(cantidad), shuffle, filter(filterCond))(argumentos)

const argumentosEsAceptable = () => condicion(2)(pro)
const argumentosNoEsAceptable = () => condicion(2)(contra)
const definiciones = () => condicion(2)(arg => arg.type === 'definicion')
const argumentosTendenciososRandom = () =>
  shuffle([argumentosEsAceptable, argumentosNoEsAceptable])[0]
const argumentosBalanceados = () => (argumentos: Argumento[]) => {
  return flatten(
    shuffle([condicion(1)(pro)(argumentos), condicion(1)(contra)(argumentos)])
  )
}

// const WORDS = 'In as name to here them deny wise this. As rapid woody my he me which. Men but they fail shew just wish next put. Led all visitor musical calling nor her. Within coming figure sex things are. Pretended concluded did repulsive education smallness yet yet described. Had country man his pressed shewing. No gate dare rose he. Eyes year if miss he as upon. In as name to here them deny wise this. As rapid woody my he me which. Men but they fail shew just wish next put. Led all visitor musical calling nor her. Within coming figure sex things are. Pretended concluded did repulsive education smallness yet yet described. Had country man his pressed shewing. No gate dare rose he. Eyes year if miss he as upon. In as name to here them deny wise this. As rapid woody my he me which. Men but they fail shew just wish next put. Led all visitor musical calling nor her. Within coming figure sex things are. Pretended concluded did repulsive education smallness yet yet described. Had country man his pressed shewing. No gate dare rose he. Eyes year if miss he as upon.'
//   .split(' ')
//   .map(x => (x.includes('.') ? x.substring(0, x.length - 1) : x))
//   .map(x => x.toLowerCase())

// const generateArgs = (dilema_id: number): Argumento[] => {
//   return Array.from({ length: 6 }).map((i, index) => {
//     const id = (dilema_id - 1) * 6 + (index + 1)
//     const type = index <= 1 ? 'pro' : index <= 3 ? 'contra' : 'definicion'
//     return {
//       id,
//       text: `Argumento ${id} (${type}):
//       ${shuffle(WORDS)
//         .join(' ')
//         .substring(0, random(180)(230))}.`,
//       type,
//     }
//   })
// }

export const DILEMAS: Dilema[] = [
  {
    id: 1,
    text: 'La oferta y demanda de trabajo sexual debería ser legal.',
    title: 'trabajo sexual',
    argumentos: [
      {
        id: 1,
        text:
          'Legalizar el trabajo sexual mejoraría la seguridad y la salud de las personas que lo ofrecen.',
        type: 'pro',
      },
      {
        id: 2,
        text:
          'La legalización ayudaría a combatir el tráfico de personas y el trabajo sexual esclavo.',
        type: 'pro',
      },
      {
        id: 3,
        text:
          'Con la legalización, las personas que se dedican al trabajo sexual pero quieren abandonarlo tendrían menos incentivos y oportunidades para hacerlo.',
        type: 'contra',
      },
      {
        id: 4,
        text:
          'El trabajo sexual alimentaría el sistema prostituyente que somete las personas a través de la explotación sexual.',
        type: 'contra',
      },
      {
        id: 5,
        text:
          'La prostitución es la práctica de mantener relaciones sexuales con otras personas a cambio de dinero u otros beneficios económicos.',
        type: 'definicion',
      },
      {
        id: 6,
        text:
          'En la antigüedad la prostitución fue una actividad habitual en la vida cotidiana de muchas ciudades, particularmente en zonas portuarias.',
        type: 'definicion',
      },
    ],
  },
  {
    id: 2,
    text: 'Todas las personas deberían ser veganas.',
    title: 'veganismo',
    argumentos: [
      {
        id: 7,
        text:
          'El veganismo como norma disminuiría significativamente la probabilidad de que los humanos se contagien de patógenos originados en animales, disminuyendo el riesgo de pandemias.',
        type: 'pro',
      },
      {
        id: 8,
        text:
          'Una humanidad vegana reduciría notablemente el sufrimiento y sacrificio evitables de millones de animales.',
        type: 'pro',
      },
      {
        id: 9,
        text:
          'El veganismo no sería viable en la práctica, fundamentalmente para las sociedades y personas menos privilegiadas económicamente.',
        type: 'contra',
      },
      {
        id: 10,
        text:
          'En muchos países el consumo de diferentes animales es parte esencial de su gastronomía. Eliminar esta posibilidad atentaría contra su identidad cultural y tradición.',
        type: 'contra',
      },
      {
        id: 11,
        text:
          'El vegetarianismo rechaza el consumo de carne pero acepta el consumo de otros productos de origen animal, como leche, huevos y queso.',
        type: 'definicion',
      },
      {
        id: 12,
        text:
          'A diferencia del vegetarianismo, el veganismo no acepta el consumo de ningùn tipo de producto o servicio de origen animal.',
        type: 'definicion',
      },
    ],
  },
  {
    id: 3,
    text:
      'La donación de órganos de personas fallecidas debería ser obligatoria.',
    title: 'donación organos',
    argumentos: [
      {
        id: 13,
        text:
          'La donación obligatoria aumentaría la cantidad de órganos disponibles, lo cual salvaría muchas vidas y mejoraría la calidad de otras tantas.',
        type: 'pro',
      },
      {
        id: 14,
        text:
          'La donación obligatoria no tiene impactos negativos para los familiares ni allegados de la persona fallecida.',
        type: 'pro',
      },
      {
        id: 15,
        text:
          'Existen estrategias para aumentar las donaciones sin que sea obligatorio. Por ejemplo, haciendo que todos sean por defecto donantes pero tengan la opción de dejar de serlo.',
        type: 'contra',
      },
      {
        id: 16,
        text:
          'A pesar de los múltiples beneficios que traería, es inmoral obligar a las personas a salvar otras vidas.',
        type: 'contra',
      },
      {
        id: 17,
        text:
          'La donación toma órganos y tejidos sanos de una persona para trasplantarlos en otras. Estos pueden incluir tanto órganos internos (riñones, corazón, hígado) como piel, hueso o córnea.',
        type: 'definicion',
      },
      {
        id: 18,
        text:
          'Si bien la mayoría de las donaciones se producen luego de que la persona ha fallecido, algunos tejidos y órganos (como el riñón) pueden donarse voluntariamente mientras el donante está vivo.',
        type: 'definicion',
      },
    ],
  },
  {
    id: 4,
    text: 'No debería haber ningún límite hacia la libertad de expresión.',
    title: 'libertad de expresión',
    argumentos: [
      {
        id: 19,
        text:
          'La libre expresión permite dialogar acerca de qué ideas resultan positivas y cuáles no. La mejor forma de garantizar esto de manera democrática es que toda persona pueda expresar libremente lo que piensa.',
        type: 'pro',
      },
      {
        id: 20,
        text:
          'No es posible establecer de manera objetiva el límite entre lo que se debería poder decir y aquello que no. Regular la libre expresión de las ideas puede llevar a la censura y a la opresión de personas o grupos.',
        type: 'pro',
      },
      {
        id: 21,
        text:
          'Algunas ideas pueden resultar ofensivas y generar daño psicológico en otras personas. Así como la violencia física es condenada por ley, también debe condenarse la violencia verbal o discursiva.',
        type: 'contra',
      },
      {
        id: 22,
        text:
          'Las ideas que promueven el odio y la violencia, así sean sólo palabras, pueden generar o desencadenar violencia física entre personas o grupos de personas.',
        type: 'contra',
      },
      {
        id: 23,
        text:
          'La libertad de expresión es un principio que sostiene que los individuos deben tener licencia para articular cualquier opinión o idea.',
        type: 'definicion',
      },
      {
        id: 24,
        text:
          'El concepto de “libertad de expresión” se remonta a, por lo menos, finales del siglo VI A.C.',
        type: 'definicion',
      },
    ],
  },
  {
    id: 5,
    text: 'La circuncisión de bebés por motivos religiosos debería prohibirse.',
    title: 'circuncisión',
    argumentos: [
      {
        id: 25,
        text:
          'Es una intervención quirúrgica no indispensable realizada sin consentimiento del paciente y por lo tanto es inaceptable.',
        type: 'pro',
      },
      {
        id: 26,
        text:
          'Las familias no deben obligar a sus hijos a tener una marca física irreversible que indica la afiliación a una religión particular.',
        type: 'pro',
      },
      {
        id: 27,
        text:
          'Es una práctica milenaria que no tiene ningún riesgo para la integridad física de las personas. Prohibirla es un acto de discriminación religiosa.',
        type: 'contra',
      },
      {
        id: 28,
        text:
          'La prohibición no serviría para detener la práctica y sólo se lograría que se realice en condiciones menos higiénicas y seguras que las actuales.',
        type: 'contra',
      },
      {
        id: 29,
        text:
          'La circuncisión es un procedimiento que consiste en cortar la piel que cubre la cabeza del pene.',
        type: 'definicion',
      },
      {
        id: 30,
        text:
          'La circuncisión es una práctica común en algunas religiones, como es el caso de musulmanes y judíos.',
        type: 'definicion',
      },
    ],
  },
]

export const getArgById = (id: number) => {
  return DILEMAS.flatMap(d => d.argumentos).find(arg => arg.id === id)!
}

type TipoDeArgumentos =
  | 'tendencioso_a_favor'
  | 'tendencioso_en_contra'
  | 'balanceado'
  | 'placebo'

export type PreArgConfig = {
  dilema: Dilema
  tipo: TipoDeArgumentos
}

export const configDilemas = () => {
  const tipos: TipoDeArgumentos[] = shuffle([
    'tendencioso_a_favor',
    'tendencioso_en_contra',
    'balanceado',
    'balanceado',
    'placebo',
  ])
  const dilemas = shuffle(DILEMAS)
  return dilemas.map((dilema, i) => ({
    dilema,
    tipo: tipos[i],
  }))
}

export const configArguments = (
  config: PreArgConfig,
  pre_aceptabilidad: number
) => {
  const {
    tipo,
    dilema: { argumentos },
  } = config
  if (tipo === 'placebo') {
    return definiciones()(argumentos)
  } else if (tipo === 'balanceado') {
    return argumentosBalanceados()(argumentos)
  } else {
    const noRespondio = pre_aceptabilidad === -999
    const noAceptable = !noRespondio && pre_aceptabilidad < 45
    const aceptable = !noRespondio && pre_aceptabilidad > 55
    const intermedio = !noRespondio && !noAceptable && !aceptable

    if (noRespondio || intermedio) {
      return argumentosTendenciososRandom()()(argumentos)
    }

    if (tipo === 'tendencioso_a_favor') {
      return (noAceptable ? argumentosNoEsAceptable : argumentosEsAceptable)()(
        argumentos
      )
    }

    if (tipo === 'tendencioso_en_contra') {
      return (noAceptable ? argumentosEsAceptable : argumentosNoEsAceptable)()(
        argumentos
      )
    }

    return argumentosTendenciososRandom()()(argumentos)
  }
}
